import React, { FunctionComponent } from "react";

const ImageFileWarningIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/files-folders/image-files/image-file-warning
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="-0.75 -0.75 48 48"
    >
      <path
        stroke="currentColor"
        d="M33.421875 40.6875a0.7265625 0.7265625 0 0 1 0 -1.453125"
      ></path>
      <path
        stroke="currentColor"
        d="M33.421875 40.6875a0.7265625 0.7265625 0 0 0 0 -1.453125"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M33.421875 34.875v-5.8125"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M44.6845625 40.071374999999996a3.4351874999999996 3.4351874999999996 0 0 1 -3.0748124999999997 4.9755h-16.37575a3.4390625 3.4390625 0 0 1 -3.0748124999999997 -4.9755l8.187875 -16.3738125a3.437125 3.437125 0 0 1 6.1496249999999995 0l8.187875 16.3738125Z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.53125 39.234375H4.359375a2.90625 2.90625 0 0 1 -2.90625 -2.90625V4.359375a2.90625 2.90625 0 0 1 2.90625 -2.90625h20.593687499999998a2.90625 2.90625 0 0 1 2.05375 0.8505625l5.5645 5.5645a2.90625 2.90625 0 0 1 0.8505625 2.05375V15.984375"
      ></path>
      <path
        stroke="currentColor"
        d="M10.171875 12.3515625a0.7265625 0.7265625 0 1 1 0 -1.453125"
      ></path>
      <path
        stroke="currentColor"
        d="M10.171875 12.3515625a0.7265625 0.7265625 0 1 0 0 -1.453125"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M24.9085 20.96375 21.796875 15.984375a1.4511875 1.4511875 0 0 0 -2.398625 -0.027125l-3.875 5.5218750000000005L13.13625 19.568749999999998a1.453125 1.453125 0 0 0 -2.1176874999999997 0.32743750000000005l-3.7529375000000003 7.71125h11.625"
      ></path>
    </svg>
  );
};

export default ImageFileWarningIcon;
